import axios from "axios";
import config from "../config";
import authHeader from "./auth-header";
import { buildClientHistoryListRequest } from "./clientHistoryRequest";

const API_URL = config.API_URL;

const view = (values = {}) => {
  const request = buildClientHistoryListRequest("afterlogin/client/clientmembership", values);
  return axios.post(API_URL + request.url, request.body, { headers: authHeader() });
};

const queryValue = (url, name) => {
  if (typeof url !== "string" || !url) return null;
  try {
    return new URL(url, "https://package-usage.invalid").searchParams.get(name);
  } catch (_error) {
    return null;
  }
};

const positiveInteger = (value) => {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
};

const usage = (values = {}) => {
  const page = positiveInteger(values.page) || positiveInteger(queryValue(values.next_page_url, "page")) || 1;
  const limit = positiveInteger(values.limit) || positiveInteger(queryValue(values.next_page_url, "limit")) || 10;
  const body = {
    client_id: positiveInteger(values.client_id),
    package_instance_id: positiveInteger(values.package_instance_id),
    page,
    limit,
  };
  return axios.post(`${API_URL}afterlogin/client/clientmembershipusage?page=${page}`, body, { headers: authHeader() });
};

const clientmembershipApiController = {
  view,
  usage,
};
export default clientmembershipApiController;
